/**
 * URL prefix the app is served from, with a trailing slash: '/' at a domain root,
 * '/apps/vds/' in a subfolder. API and asset requests are built on it, so the same
 * build works anywhere (the hash router takes care of the rest).
 */
export const APP_BASE: string = (() => {
  if (typeof window === 'undefined') return '/';
  const p = window.location.pathname;
  return p.endsWith('/') ? p : p.slice(0, p.lastIndexOf('/') + 1);
})();

export const assetsUrl = (id: string, variant: string): string =>
  `${APP_BASE}assets.php?a=${encodeURIComponent(id)}&v=${encodeURIComponent(variant)}`;
